const DropdownItem = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default DropdownItem;
